
<label class="label">
  <input
    type="radio"
    class="radio"
    :name="name"
    :value="value"
    :checked="is_checked"
  >
  <div class="button" />
  <span class="ml10">{{ title }}</span>
</label>
